import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Optional, Output, ViewEncapsulation } from '@angular/core';
import { Bullet20 } from '../../icon/icon-map';
import { ISelectedRange } from './../../date-picker/utils/types';
import { PHX_LOCALE_PROVIDER, PhxLocaleProvider } from '../../locale/phx-locale.token';
import { dateFormatter } from '../../../utils';
import { PhxTranslationService } from '../../../translation/translation.service';
import { mapToDateFnsLocale } from '../../date-picker/utils/helpers';

@Component({
  selector: 'phx-month-picker-footer',
  templateUrl: './phx-month-picker-footer.component.html',
  styleUrls: ['./phx-month-picker-footer.component.scss'],
  host: {
    class: 'phx-month-picker-footer',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxMonthPickerFooterComponent {
  @Input() public selectedValue: ISelectedRange | null = null;

  @Output() public clear = new EventEmitter<void>();

  public readonly bulletIcon: string = Bullet20;

  constructor(
    private translationService: PhxTranslationService,
    @Optional() @Inject(PHX_LOCALE_PROVIDER) private phxLocale: PhxLocaleProvider | null,
  ) {}

  public formatMonth(date: Date): string {
    if (this.phxLocale?.formatMonth) {
      return this.phxLocale.formatMonth(date);
    }
    const locale = mapToDateFnsLocale(this.translationService.getLocale());
    return dateFormatter(date, 'MMM', locale);
  }

  public formatYear(date: Date): string {
    return date.getFullYear().toString();
  }

  public onClear(): void {
    this.clear.emit();
  }
}
